import React, { Component } from "react";
import Carousel from "../Carousel";
import styles from "./Testimonials.module.scss";

const Testimonials = props => (
	<div className={ "container " + styles.testimonial_wrapper} >
		<div className="row">
			<div className="col-12">
				<Carousel testimonials={props.testimonials}/>
			</div>
		</div>
	</div>
);

export default Testimonials;



// WEBPACK FOOTER //
// ./src/components/testimonials/index.js